export default __webpack_public_path__ + "static/media/Highbay trad.4779bbd3.png";